<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/91C7IY/tc-custom/9781632657961.jpg?1705030456828" alt="This image is the cover for the book Raising Witches"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Raising Witches
      </h1>
      <p class="bookDescription body article font2">
        <p>This is the first book that gives parents the means to teach their children Wicca in a more formal fashion. Featuring a Wiccan curriculum for each of the five age groups from infancy to young adulthood, O'Gaea shows parents how to effectively weave Wicca into a child's natural progression of learning.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ashleen O'Gaea
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Page Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a0ef1d8c